module.exports = __webpack_public_path__ + "20260611d121505t/img/production-pic.2a7c54ea.png";